define('app/views/dc_deal_toolkit_view',['app/setup'], function (takhfifan) {
  takhfifan.dcDealToolkit = takhfifan.BaseView.extend({
    shareBoxTemplate: ( $('#tkh-dc-share-box-template').length > 0 ) ?
      _.template( $('#tkh-dc-share-box-template').html() ) : '',

    events: {
      'click .tkh-dc-deal-toolkit__share': 'toggleShareOptions',
      'click .tkh-dc-deal-toolkit__dislike': 'sendDislike',
      'click .tkh-dc-deal-toolkit__like': 'sendLike'
    },

    initialize: function () {
      var _this = this;
      this.productId = this.$el.data('id');
      this.productTitle = encodeURIComponent(this.$el.parents('.dc-item').find('.dc-item__title').text());
      this.$shareBtn = this.$('.tkh-dc-deal-toolkit__share');
      this.$shareBtn.after(this.shareBoxTemplate({productId: _this.productId, productTitle: _this.productTitle}));
      this.likeUrl = this.$el.data('likeUrl');
      this.disLikeUrl = this.$el.data('disLikeUrl');
      this.setFill();
    },

    toggleShareOptions: function (e) {
      e.preventDefault();
      e.stopPropagation();
      var $p = this.$shareBtn.parent('.dc-item-tools__share-wrapper');
      if($p.hasClass('active')){
        $(document).off('click.dcshare');
        $p.removeClass('active');
      }else{
        $(document).on('click.dcshare', function (e) {
          $('.dc-item-tools__share-wrapper.active').removeClass('active');
        });
        $p.addClass('active');
      }
    },

    sendLike: function (e) {
      e.preventDefault();
      this.sendData(true);
    },

    sendDislike: function (e) {
      e.preventDefault();
      this.sendData(false);
    },

    sendData: function (isLike) {
      var _this = this,
          url = this.likeUrl;
      this.$el.addClass('loading-view');
      if(!isLike){
        url = this.disLikeUrl;
      }
      $.ajax({
        method: "POST",
        url: url,
        data: {
          form_key : takhfifan.formKey,
          product_id : this.productId
        }
      })
        .done(function (data) {
          // data.status could be "already-exists" or "success"
          if(data.success){
            takhfifan.eventHub.trigger('message:show', {
              msg: data.message || 'با تشکر، نظر شما ثبت شد',
              type: 'success'
            });
            _this.$('.tkh-dc-deal-toolkit__like').attr('data-count',data.like);
          }else{
            takhfifan.eventHub.trigger('message:show', {
              msg: data.message || 'در برقراری ارتباط خطایی پیش آمد',
              type: 'error'
            });
          }
        })
        .fail(function () {
          takhfifan.eventHub.trigger('message:show', {
            msg: data.message || 'در برقراری ارتباط خطایی پیش آمد',
            type: 'error'
          });
        })
        .always(function () {
          _this.$el.removeClass('loading-view');
        });
    },

    setFill: function() {
      var $starsFill = this.$('.tkh-stars-fill');
      var rating = parseFloat($starsFill.data('rating'));
      $starsFill.width((rating * 20 - 2)+"%");
    }

  });
});

